module.exports = __webpack_public_path__ + "img/bg35.968b747b.jpg";